export default "__VITE_ASSET__BIQeYJn6__"